import { render, staticRenderFns } from "./bao-cao-tien-ship.vue?vue&type=template&id=85479132&scoped=true&"
import script from "./bao-cao-tien-ship.vue?vue&type=script&lang=js&"
export * from "./bao-cao-tien-ship.vue?vue&type=script&lang=js&"
import style0 from "./bao-cao-tien-ship.vue?vue&type=style&index=0&id=85479132&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85479132",
  null
  
)

export default component.exports